






import { Component, Mixins, Prop, Emit } from "vue-property-decorator";
import { FixedPhraseRootReference } from "../../../domain/document";
import { FixedLoading } from "../../system";
import FixedPhraseTreeSelector from "./FixedPhraseTreeSelector.vue";
import { FixedPhraseTreeSelectorMixin } from "./mixins";
import { IEditFixedPhrase } from "./IEditFixedPhrase";
import { FixedPhraseKinds } from "./FixedPhraseKinds";

@Component({
  components: {
    FixedLoading,
    selector: FixedPhraseTreeSelector,
  }
})
export default class UserFixedPhraseSelector extends Mixins(
  FixedPhraseTreeSelectorMixin,
) implements IEditFixedPhrase {
  @Prop()
  userId: string;

  @Prop({ default: true })
  isPastable: boolean;

  created(): void {
    this.getFixedPhrase(FixedPhraseKinds.User, this.userId)
    .then(d => this.rootFixedPhrase = d)
    .catch(e => {
      this.rootFixedPhrase = new FixedPhraseRootReference(null, null, []);
      this.$error(
        "個人定型文取得失敗",
        "個人定型文を読み込めませんでした。",
        e,
      );
    });
  }

  mounted(): void {
    this.selector = this.$refs.selector;
  }

  @Emit("doubleClicked")
  doubleClicked(): void {}

  @Emit("dragStart")
  dragStart(event: DragEvent, text: string): void {}

  async editFixedPhrase(): Promise<void> {
    if (!this.isLoaded) {
      return;
    }
    const latest = await this.getFixedPhrase(FixedPhraseKinds.User, this.userId);
    const result = await this.getEditedFixedPhrase(latest, FixedPhraseKinds.User, this.userId);
    if (result == null) { return; }
    await this.setFixedPhrase(FixedPhraseKinds.User, result);
  }
}
